export const baseURL_LOCAL = '/api';
export const baseURL_DEV = '/api';
export const baseURL_STAGE = '/api';
export const baseURL_PROD = '/api';
/**
 * The frontend always calls a relative `/api` path. Routing to the actual
 * backend is handled at the edge:
 *   - local:           webpack-dev-server `proxy` forwards /api/* to the
 *                      BACKEND_URL env var (default http://localhost:81).
 *   - dev/stage/prod:  nginx (see nginx/app.conf.template) proxies /api/*
 *                      to the backend container.
 * Keeping the URL relative means no CORS, no per-env compile differences,
 * and cookies are sent automatically.
 */
export function getBaseURL() {
    const env = (process.env.APP_ENV || 'prod').toLowerCase();
    if (env === 'local')
        return baseURL_LOCAL;
    if (env === 'dev')
        return baseURL_DEV;
    if (env === 'stage' || env === 'staging')
        return baseURL_STAGE;
    return baseURL_PROD;
}
export const endpoints = {
    allReviewData: '/allReviewData',
    recentReviews: '/recentReviews',
    reviewStatus: '/reviewStatus',
    cardDetailsByReviewId: '/cardDetailsByReviewId',
    runComplianceReview: '/runComplianceReview',
    downloadDocument: '/downloadDocument',
    uploadToDocStore: '/uploadToDocStore',
    extractedDocuments: '/retrieveProcessedFiles',
    retrieveProcessedFilesDetails: '/retrieveProcessedFilesDetails',
    retrieveSourceFilesDetails: '/retrieveSourceFilesDetails',
    saveProcessedFile: '/saveProcessedFile',
    originalDocuments: '/retrieveSourceFiles',
    duplicateDocument: '/duplicateDocument',
    copySupportDoc: '/copySupportDoc',
    saveCSWFile: '/saveCSWFile',
};
